import './index.css'

const PasswordItem = props => {
  const {passwordDetails, isPasswordVisible, deletePasswordItem} = props
  const {id, website, username, password, initialClassName} = passwordDetails

  const initialLetter = website ? website.slice(0, 1).toUpperCase() : ''

  const onDeleteItem = () => {
    deletePasswordItem(id)
  }

  return (
    <li className="password-item">
      <div className="item-content-container">
        <div className={`profile-avatar ${initialClassName}`}>
          <span className="avatar-text">{initialLetter}</span>
        </div>
        <div className="text-details-container">
          <p className="detail-text website-title">{website}</p>
          <p className="detail-text username-text">{username}</p>
          {isPasswordVisible ? (
            <p className="detail-text password-text">{password}</p>
          ) : (
            <img
              src="https://assets.ccbp.in/frontend/react-js/password-manager-stars-img.png"
              alt="stars"
              className="stars-img"
            />
          )}
        </div>
      </div>
      <button
        type="button"
        className="delete-button"
        onClick={onDeleteItem}
        data-testid="delete"
      >
        <img
          src="https://assets.ccbp.in/frontend/react-js/password-manager-delete-img.png"
          alt="delete"
          className="delete-icon"
        />
      </button>
    </li>
  )
}

export default PasswordItem
